import type {CSSProperties, PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {useAccordionContext} from "../hooks/use_accordion_context";
import {useContentHeight} from "../hooks/use_content_height";
import type {AccordionTheme} from "../types/AccordionTheme";

import * as styles from "./Content.module.css";

export interface IProps {
    className?: string;
    wrapStyle?: CSSProperties;
}

type ClassName = keyof typeof styles;

const getContentTheme = (theme: AccordionTheme) => `content${capitalize(theme)}` as ClassName;

export const Content = (props: PropsWithChildren<IProps>) => {
    const context = useAccordionContext(Content.name);

    const {contentRef, contentHeight} = useContentHeight();

    return (
        <div
            className={cn(styles.wrapper, !context.expanded && styles.hidden)}
            style={{height: context.expanded ? contentHeight || "auto" : 0, ...props.wrapStyle}}
        >
            <div className={cn(styles.content, styles[getContentTheme(context.theme)], props.className)} ref={contentRef}>
                {props.children}
            </div>
        </div>
    );
};
